module.exports = __webpack_public_path__ + "img/g矩形 87@1x.ccff5dfa.png";